<script setup lang="ts">
import { onMounted, ref } from 'vue';
import ActivityAttendanceChart from './ActivityAttendanceChart.vue';
import ActivityAttendanceCalendarList from './ActivityAttendanceCalendarList.vue';
import { useAttendanceStore } from '@/store';
import { useRouting } from '@/composables';
import { useDateTime } from '@/composables';

const dates = ref([]);
const AttendanceStore = useAttendanceStore();
const $routing = useRouting();

onMounted(() => init());

const init = async () => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  const start = new Date(year, month, 1);
  const end = new Date(year, month, 28);

  dates.value = [start, end];

  const startDate = useDateTime().formatDateForApi(start);
  const endDate = useDateTime().formatDateForApi(end);

  AttendanceStore.setDates(startDate, endDate);
  await AttendanceStore.getAttendanceResults(Number($routing.route.params.id));
  await AttendanceStore.getTherapyResults(Number($routing.route.params.id), startDate, endDate);
};

const onDateRangeChange = async (event) => {
  const startDate = event[0] ? useDateTime().formatDateForApi(event[0]) : null;
  const endDate = event[1] ? useDateTime().formatDateForApi(event[1]) : null;

  if (startDate && endDate) {
    AttendanceStore.setDates(startDate, endDate);
    await AttendanceStore.getAttendanceResults(Number($routing.route.params.id));
    await AttendanceStore.getTherapyResults(Number($routing.route.params.id), startDate, endDate);
  }
};
</script>

<template>
  <Card class="page-content-half flex flex-column">
    <template #header>
      <h2>Attendance</h2>
    </template>
    <template #content>
      <div class="w-full p-input-icon-left">
        <IconField icon-position="left">
          <InputIcon class="p-input-icon-left" style="z-index: 100">
            <Icon name="calendar_today" class="text-lg z-1" />
          </InputIcon>
          <AppDateRangePicker v-model="dates" class="w-full" :value="dates" @change="onDateRangeChange" />
        </IconField>
      </div>
      <ActivityAttendanceChart />
      <ActivityAttendanceCalendarList />
    </template>
  </Card>
</template>

<style scoped lang="scss">
.daterangepicker-container {
  :deep(.p-inputtext) {
    font-weight: bold;
    padding-left: 30px;
  }
}
</style>
